<template>
  <memlist-card>
    <m-row>
      <m-col lg="12">
        <p>
          För att kunna ta emot kreditkortsbetalning, påbörja guiden genom att klicka på knappen nedan.
        </p>
      </m-col>
    </m-row>

    <m-row class="mt-4">
      <m-col lg="12">
        <div ref="stripeMountPoint" />
      </m-col>
    </m-row>

    <m-row class="mt-4">
      <m-col lg="12">
        <memlist-button @click="startOnboarding" variant="primary">Skapa Kreditkortbetalningar</memlist-button>
      </m-col>
    </m-row>
  </memlist-card>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import { loadConnectAndInitialize } from '@stripe/connect-js';


export default {
  name: 'StripeEmbeddedOnboarding',
  mixins: [ toasts ],
  data() {
    return {
      stripe: null,
      connectInstance: null,
      accountId: null,
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods', 'settings']),
  },
  mounted() {

  },
  methods: {

    async startOnboarding() {
      try {
        
        const response = await axios.post(`/stripe/account/${this.currentCompanyId}`);
        if (response.status !== 201) throw new Error('Account creation failed');

        const clientSecret = response.data.client_secret;


        const connectInstance = loadConnectAndInitialize({
          publishableKey: 'pk_live_51LmGDcIuHfUPCULWyvTPDsIjc2p9jdv4wq84jWJKrTLQdrEJIIUHsP5xCRdLvFpq6JVAiJc1ZKrVlTjoYD4pMFOB000af2dLsk',
          fetchClientSecret: async () => clientSecret,
        });

        const onboardingElement = connectInstance.create('account-onboarding');

        onboardingElement.setOnExit(() => {
          this.$emit('onboarding-exited');
        });

        this.$refs.stripeMountPoint.appendChild(onboardingElement);
      } catch (err) {
        console.error('Stripe onboarding error:', err);
        this.toastr('danger', 'Error', 'Unable to start onboarding.');
      }
    },
/*
    async startOnboarding() {
      try {
        // Step 1: Ask your backend to create or fetch a connected account
        const response = await axios.post(`/stripe/account/${this.currentCompanyId}`);

        if (response.status === 201) {
          this.accountId = response.data.account_id;
          const clientSecret = response.data.client_secret;

          const connectInstance = await loadConnectAndInitialize('pk_live_51LmGDcIuHfUPCULWyvTPDsIjc2p9jdv4wq84jWJKrTLQdrEJIIUHsP5xCRdLvFpq6JVAiJc1ZKrVlTjoYD4pMFOB000af2dLsk');

          const elements = connectInstance.elements({ clientSecret });
          const onboarding = elements.create('connect-account-onboarding');
          onboarding.mount(this.$refs.stripeMountPoint);

          onboarding.on('exit', () => {
            this.$emit('onboarding-exited');
          });
        }

        
      } catch (err) {
        console.error('Stripe onboarding error:', err);
        this.toastr('danger', 'Error', 'Unable to start onboarding.');
      }
    },*/
  },
};
</script>
